module.exports = __webpack_public_path__ + "media/images/principal-bf973816f7ccaccea840d3b836868a45.png";